module.exports = __webpack_public_path__ + "img/Maagtechnic_Grafik_3D_fr-FR.2246511d.png";